import { useFlags } from '@mint-lib/routing-context';

export const useWithConfiguredMediaRowsFF = () => {
  const ff = useFlags('@mint/arm', ['withConfiguredMediaRows']);

  return ff.withConfiguredMediaRows.enabled;
};
